import { createApp } from 'vue';
import 'vue-next-select/dist/index.css';
import ConfigInterface from '@/interfaces/ConfigInterface';
import ListSectionInterface from '@/interfaces/ListSectionInterface';
import ButtonIconRound from '@/components/ButtonIconRound.vue';
import Hero from '@/components/Hero.vue';
import TextSection from '@/components/TextSection.vue';
import TextSectionHeadline from '@/components/text_section/TextSectionHeadline.vue';
import TextSectionContent from '@/components/text_section/TextSectionContent.vue';
import ProjectArea from '@/components/ProjectArea.vue';
import PageIconCardsGrid from '@/components/PageIconCardsGrid.vue';
import PageIconCard from '@/components/PageIconCard.vue';
import SectionSpacerClouds from '@/components/partials/SectionSpacerClouds.vue';
import SectionSpacerBar from '@/components/partials/SectionSpacerBar.vue';
import ListSection from '@/components/ListSection.vue';
import CkButton from '@/components/Button.vue';
import ListSectionItem from '@/components/list_section/ListSectionItem.vue';
import CardsGridSection from '@/components/CardsGridSection.vue';
import CardDistrictOffice from '@/components/CardDistrictOffice.vue';
import CardContactPerson from '@/components/CardContactPerson.vue';
import CardPartner from '@/components/CardPartner.vue';
import Container from '@/components/Container.vue';
import PageError from '@/components/PageError.vue';
import EventOverview from '@/components/EventOverview.vue';
import JobMarket from '@/components/JobMarket.vue';
import CardEmployer from '@/components/CardEmployer.vue';
import App from './App.vue';
import router from './router';
import store from './store';

declare global {
  interface Window {
    ioappConfig: ConfigInterface,
    currentListSection: ListSectionInterface,
  }
}

createApp(App)
  .component('Hero', Hero)
  .component('CkButton', CkButton)
  .component('ButtonIconRound', ButtonIconRound)
  .component('TextSection', TextSection)
  .component('TextSectionHeadline', TextSectionHeadline)
  .component('TextSectionContent', TextSectionContent)
  .component('ProjectArea', ProjectArea)
  .component('PageIconCardsGrid', PageIconCardsGrid)
  .component('PageIconCard', PageIconCard)
  .component('SectionSpacerClouds', SectionSpacerClouds)
  .component('SectionSpacerBar', SectionSpacerBar)
  .component('ListSection', ListSection)
  .component('ListSectionItem', ListSectionItem)
  .component('CardsGridSection', CardsGridSection)
  .component('CardDistrictOffice', CardDistrictOffice)
  .component('CardContactPerson', CardContactPerson)
  .component('EventOverview', EventOverview)
  .component('CardPartner', CardPartner)
  .component('Container', Container)
  .component('PageError', PageError)
  .component('JobMarket', JobMarket)
  .component('CardEmployer', CardEmployer)
  .use(store)
  .use(router)
  .mount('#ioapp');
